import React, { useEffect, useState } from 'react';
import { FlexRow, H2Text } from '@minecraft.atoms';
import { calculateTimeLeft } from '@minecraft.date-utils';

const TimeTypeSuffixMap = {
  days: 'd',
  hours: 'h',
  minutes: 'm',
  seconds: 's',
};

const TimeTile = ({ time, timeSuffix }: { time: string; timeSuffix: string }) => (
  <FlexRow gap="1" bgColor="cardHighlight" className="cn_atom_p-4" borderRadius="xl" alignItems="center">
    <H2Text fontWeight="bold">{time} </H2Text> <H2Text fontWeight="regular">{timeSuffix}</H2Text>
  </FlexRow>
);

export const CountdownTimer = ({ endsAt }: { endsAt: Date }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endsAt));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(endsAt));
    }, 1000);

    return () => clearInterval(interval);
  }, [endsAt]);

  return (
    <FlexRow gap="1" alignItems="center">
      {Object.entries(timeLeft).map(([timeType, time]) => (
        <FlexRow key={timeType} alignItems="center" gap="1" data-testid={`countdown-${timeType}`}>
          <TimeTile time={time.toString().padStart(2, '0')} timeSuffix={TimeTypeSuffixMap[timeType]} />
          {timeType !== 'seconds' && <H2Text fontWeight="semibold">:</H2Text>}
        </FlexRow>
      ))}
    </FlexRow>
  );
};
